import { avatarColor, avatarInitials } from "@/lib/avatar";

/**
 * Compact horizontal stack of up to 4 member avatars + "+N" overflow.
 * Used in the shared-session header and above the chat composer when the
 * owner has active viewers.
 */
export default function PresenceAvatars({ members = [], max = 4 }) {
    if (!members || members.length === 0) return null;
    const shown = members.slice(0, max);
    const extra = members.length - shown.length;

    return (
        <div
            className="flex items-center -space-x-1.5"
            data-testid="presence-avatars"
        >
            {shown.map((m, i) => {
                const seed = m.avatar_seed || m.user_id || m.name || `p-${i}`;
                const color = avatarColor(seed);
                return (
                    <span
                        key={seed + i}
                        title={`${m.name || "Guest"}${m.is_owner ? " (owner)" : ""}`}
                        className="relative inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-white text-[10.5px] font-semibold text-white shadow-sm"
                        style={{ backgroundColor: color }}
                        data-testid="presence-avatar"
                    >
                        {avatarInitials(m.name || "?")}
                    </span>
                );
            })}
            {extra > 0 && (
                <span
                    className="relative inline-flex h-7 w-7 items-center justify-center rounded-full border-2 border-white bg-[#F5F5F5] text-[10px] font-semibold text-[#0A0A0A]"
                    data-testid="presence-avatar-overflow"
                >
                    +{extra}
                </span>
            )}
        </div>
    );
}
